import { useMatch } from 'react-router-dom';

import { routes } from '~/shared/config/routes';
import { useAuthStore } from '~/shared/model/auth';
import { LinkTypes } from '~/shared/model/link-types.ts';
import { Logo } from '~/shared/ui/logo';

import { BurgerMenu, SidebarMenu } from '~/entities/navigation';

import { LoginButton } from '~/features/authorization/login';

import { Navigation } from './Navigation';
import { UserSection } from './UserSection';

export function TopBarWidget() {
  const isAuthorized = useAuthStore((state) => state.isAuthorized);

  // TODO Add "admin or teacher" check
  const isDashboardLayout = useMatch({
    path: routes.dashboard.get(),
    end: false,
  });

  return (
    <header className="flex items-center justify-between">
      <Logo />
      <nav className="flex flex-row items-center gap-2 sm:gap-4">
        {!isDashboardLayout && (
          <Navigation className="hidden gap-4 text-lg lg:flex" />
        )}
        <div>{isAuthorized ? <UserSection /> : <LoginButton />}</div>

        {isDashboardLayout ? (
          <SidebarMenu linkType={LinkTypes.TEACHER} />
        ) : (
          <BurgerMenu linkType={LinkTypes.BASE} />
        )}
      </nav>
    </header>
  );
}
